import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { FieldSpec } from '@k2/common/k2-forms-state/types';
import { FieldSpecValueFormatter } from '@k2/common/k2-forms/field-spec/field-spec-value-formatter';

@Component({
    selector: 'field-spec-value',
    templateUrl: 'field-spec-value.component.html',
    styleUrls: ['field-spec-value.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FieldSpecValueComponent implements OnChanges {
  @Input() fieldSpec: FieldSpec;
  @Input() emptyMessage = 'Not specified';

  formattedValue: string;

  constructor(private formatter: FieldSpecValueFormatter) {}

  ngOnChanges(): void {
    this.formattedValue = this.formatter.format(this.fieldSpec);
  }
}
